import { Input, Component } from '@angular/core';

import { PhcAppMenuItem } from '../../classes/phc-app/phc-app';

/**
 * Generated class for the PhcMenuItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'phc-menu-item',
  templateUrl: 'phc-menu-item.html'
})
export class PhcMenuItemComponent {

  @Input()
  item: PhcAppMenuItem;

  constructor() {
    console.log('Hello PhcMenuItemComponent Component');
  }

}



// WEBPACK FOOTER //
// ./src/components/phc-menu-item/phc-menu-item.ts